export const projectFilterSwiperOptions = {
    spaceBetween: 8,

    breakpoints: {
        319: {
            spaceBetween: 4,
            slidesOffsetAfter: 16,
        },
        464: {
            spaceBetween: 8,
        },
    },
};
